import React, { Component } from "react";
import { Button } from "react-bootstrap";
import ReactTable from "react-table";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { api_url_cartoes_image } from "../providers/api";

export default class TBLCartoes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pages: 0,
      page: 0,
      limit: 10,
      loading: false,
    };

    this.columns = [
      {
        Header: "Tipo",
        accessor: "tipo",
        Cell: (props) => <span>{props.value === "credito" ? "Crédito" : "Débito"}</span>,
        className: "center",
      },
      {
        Header: "Bandeira",
        accessor: "bandeira",
        Cell: (row) => (
          <div>
            <img
              src={`${api_url_cartoes_image}/${row.row._original.logo}`}
              alt="logo_cartao"
              height="30px"
              width="30px"
            />{" "}
            <span>{row.row._original.bandeira}</span>
          </div>
        ),
      },
      {
        Header: "Ações",
        Cell: (row) => {
          return (
            <div>
              <Button
                size="sm"
                variant="danger"
                onClick={() => this.gerenciarAcoes("deletar", row.row._original)}
              >
                <FontAwesomeIcon icon={faTrash}></FontAwesomeIcon>
              </Button>
            </div>
          );
        },
        className: "center",
      },
    ];
  }

  gerenciarAcoes = (tipo, dados) => {
    if (tipo === "deletar") {
      this.props.dataCallback(tipo, dados);
    } else {
      return;
    }
  };

  render() {
    return (
      <ReactTable
        data={this.props.data}
        columns={this.props.showAcoes ? [...this.columns, ...this.acoes] : this.columns}
        resizable
        pages={this.state.pages}
        className="-striped -highlight"
        manual
        style={{
          height: this.props.height || 572,
          maxHeight: 572,
        }}
        onPageChange={(page) => this.setState({ page })}
        showPagination={this.props.showPagination}
        defaultPageSize={this.state.limit}
        previousText="Anterior"
        nextText="Próximo"
        loadingText="Carregando métodos..."
        noDataText="Nenhum método de pagamento encontrado!"
        pageText="Página"
        ofText="de"
        rowsText="linhas"
      />
    );
  }
}

TBLCartoes.propTypes = {
  data: PropTypes.array,
  showPagination: PropTypes.bool,
  dataCallback: PropTypes.func,
  arrayCallback: PropTypes.func,
  showAcoes: PropTypes.bool,
  carregarDados: PropTypes.bool,
  height: PropTypes.number,
};
